// import * as $ from 'jquery';
// import * as $ from 'javascript-detect-element-resize';
// import $ from '../../../app/jquery.resize';
import * as d3 from 'd3';
import { ILogger, LoggerFactory } from '../helpers/helpers';
import { IMargins } from '../models/IMargins';

export class SvgManager {
    private _container;
    private _margins: IMargins;
    private _resizeFunctions: ((width: any, height: any) => void)[];
    private _containerName: string;
    private _chartsCount: number;
    private _logger: ILogger;
    private _height: number;

    constructor(containerName: string, margins: IMargins) {
        this._logger = LoggerFactory.getLogger('WideTech.Charting.svgManager');
        this._containerName = containerName;
        this._resizeFunctions = [];
        this._container = d3
            .select(`#${this._containerName}`)
            .selectAll('svg');
        this.margins(margins);
        this._chartsCount = 0;
        try {
            ($(`#${this._containerName}`) as any).resize(() => this.resizeSVG());
        } catch (e) {
            console.error(e);
        }
    }

    private resizeSVG(): void {
        //Hide svg to measure the container (problem with flexbox)
        try {
            this._container.style('display', 'none');
            const size = this.getSize();
            this._container.style('display', null);
            const width = size.width;

            this._container.attr({
                'width': width,
                'height': this._height ? this._height : size.height
            });

            const chartsCount = this._chartsCount ? this._chartsCount : 1;
            const height = size.height / chartsCount;
            this._logger.debug(`Resizing svg: width: ${width}, height:${height}`);
            this._resizeFunctions.forEach(f => {
                f(width, height);
            });
        } catch (e) {
            console.error(e);
        }
    }

    addResizeFunction(value: (width: any, height: any) => void): void {
        this._resizeFunctions.push(value);
    }

    clearResizeFunctions() {
        while (this._resizeFunctions.length > 0) {
            this._resizeFunctions.pop();
        }
    }

    getSize() {
        let div = $(`#${this._containerName}`).trigger('select');
        if (div.length === 0 && this._container[0].parentNode.id) {
            div = $(`#${this._container[0].parentNode.id}`).select();
            if (div.length > 0) {
                this._containerName = div[0].id;
            }
        }
        let width = div.width() - this._margins.marginLeft - this._margins.marginRight;
        if (width <= 0) {
            width = 300;
        }
        let height = div.height() - this._margins.marginTop - this._margins.marginBottom;
        if (!height || height <= 0) {
            height = width * 3 / 4;
        }
        const result = { width: width, height: height };
        return result;
    }

    margins(value?: IMargins): IMargins {
        if (value) {
            this._margins = value;
            this.resizeSVG();
        }
        return this._margins;
    }

    container(): d3.Selection<any> {
        return this._container;
    }

    addChart() {
        this._chartsCount++;
    }
    setHeight(value: number): void {
        this._height = value;
        d3.select(`#${this._containerName}`).select('svg').attr('height', value);
    }
}